<template>
<div class='fullscreen' ref="fullscreen">
  <h1>
    <img src="/static/img/pages/bokumetsu/gacha-h1.svg" alt="yagish（ヤギッシュ）秘密のガチャガチャ">
  </h1>
  <div class="tadoritsuiteerai">
    <div class="textboard">
      <p class="textboard-content">
        選ばれし勇者よ。よくここまでたどり着いた。
      </p>
    </div>
  </div>
  <div class="gacha-wrapper">
    <div class="world-wrapper" :style="worldWrapperStyle">
      <canvas ref="world" id="world" :style="worldStyle"></canvas>
      <div class="gachanodai">
        <img src="/static/img/pages/bokumetsu/gachanodai.svg" alt="ガチャガチャの台">
      </div>
      <div class="gacha-control">
        <div class="el-button-container">
          <el-button @click="openPlug" :disabled="nowLoding" class="standard">BUTTON</el-button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="$firebase.isAuthenticated" class="statistics">
    <p><img src="/static/img/pages/bokumetsu/yagikore.svg" alt="ヤギコレクション" class="yagikore"></p>
    <ul v-if="omikujiStatistics">
      <li v-for="(count,index) in omikujiStatistics.rarityCounts" :key="index" :index="index">
        <img :src="getYagiImgByRarity(index)" class="tobuyagi"><p class="number-collections">{{ count}}<img src="/static/img/pages/bokumetsu/yagisuu.svg" alt="yagi"></p>
      </li>
    </ul>
    <p v-else class="empty-yagi">集めたヤギの数がここに表示されます🐐</p>
    <!--{{ rateTable }}-->
  </div>
  <div v-else class="statistics login">
    ログインするとyagiコレクションの記録を残せるよ！
  </div>
  <modal name="omikuji-dialog"
    class="omikuji-dialog"
    :adaptive="true"
    :scrollable="true"
    :clickToClose="false"
    height="auto"
    width="100%">
  <div class="omikuji-area"
    v-if="omikuji">
      <div :class="rarityClass">
      <div>{{ rarityLabel }}</div>
      <div v-if="errorMessage">画像の取得に失敗しました。再度お試しください。</div>
      <div v-if="nowLoding"
        class="now-loading"
        :class="rarityClass">
        <i class="el-icon-loading"></i>
      </div>
      <div v-else>
        <a :href="omikujiUrl"><img v-if="omikujiSrc"
          :src="omikujiSrc"
          class="omikuji-result-img"></a>
      </div>
    </div>
    <div v-if="yagiImgSrc" class="result-yagi-image">
      <img :src="yagiImgSrc" alt="yagi">
    </div>
    <div class="close-button flexbox"
      v-if="omikuji && omikujiSrc">
      <div class="gacha-control">
        <el-button class="again" @click="omikuji=null; $modal.hide('omikuji-dialog');openPlug()" :disabled="nowLoding"><img src="/static/img/pages/bokumetsu/yagiokawari.svg" alt="もう一回まわす"></el-button>
      </div>
      <el-button class="close" type="text"
        @click="omikuji=null; $modal.hide('omikuji-dialog')"><img src="/static/img/pages/bokumetsu/yagitojiru.svg" alt="閉じる"></el-button>
    </div>
  </div>
  </modal>
</div>
</template>
<style lang="scss" scoped>
.flexbox{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}
h1{
  text-align: center;
  margin-top: 30px;
}
h1 img{
  max-width: 300px;
}
.container{
  margin-top:100px;
}
.statistics{
  color: #fff;
  max-width: 640px;
  margin: 0 auto 35px;
}
.statistics ul{
  max-width: 100%;
  background: #000;
  border-radius: 20px;
  padding: 30px 30px 20px;
}
.statistics li{
  text-align: center;
  display: inline-block;
  margin-right: 35px;
  &:last-child{
    margin-right: 0;
  }
}
.number-collections{
  font-size: 1.5rem;
  font-weight: bold;
  margin-left: 15px;
  img{
    max-width: 40px;
    margin-left: 2px;
  }
}

.world-wrapper{
  margin-top:30px;
  text-align: center;
  position: relative;
}

.gacha-control{
  text-align: center;
  margin:30px 0 60px;
}

.omikuji-area{
  text-align: center;
}

.omikuji-result-img {
  max-width: 100%;
  height: auto;
}

.close-button{
  max-width: 320px;
  margin: 0 auto;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-top: 30px;
  .gacha-control{
    margin: 0;
  }
  el-button:hover{
  }
}

.again{
  min-width: 150px;
  min-height: 100px;
  background: #f18bae;
  &:hover{
    background: #ccc;
    border: none;
  }
}
.again img{
  max-width: 100px;
}

.close{
  min-width: 150px;
  min-height: 100px;
  background: #333;
  &:hover{
    background: #ccc;
  }
}
.close img{
  max-width: 80px;
}

.all-container{
  margin: 0 50px;
}

.fullscreen{
  overflow: hidden;
  // background: #efefef;
  background-image: url(/static/img/pages/bokumetsu/repeatbg.png);
  background-size: 30%;
}
.result-yagi-image{
  padding: 80px 0;
  background:url(/static/img/pages/bokumetsu/gacha-yagibg.png) no-repeat center;
  max-width: 300px;
  margin: 30px auto 0;
}

.now-loading {
  font-size: 160px
}

.rarity-1, .rarity-2, .rarity-3, .rarity-4, .rarity-5{
  border-radius: 10px;
  margin: 10px 50px;
}

.rarity-1 {
  background-color: white;
}

.rarity-2 {
  background-color: lightcyan;
}

.rarity-3 {
  background-color: skyblue;
}

.rarity-4 {
  background-color: plum;
}

.rarity-5 {
  background-color: gold;
}

.tadoritsuiteerai{
  margin: 0 auto;
  max-width: 400px;
}

.textboard {
  font-weight: bold;
  font-size: 0.8rem;
  max-width: 600px;
  min-height: 50px;
  font-size: 1rem;
  color: #fff;
  border: 2px solid #000;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 0 4px #fff inset;
          box-shadow: 0 0 0 4px #fff inset;
  background-color: rgba(0,0,0,0.9);
  margin: 20px auto;
  padding: 20px;
}
@-webkit-keyframes typing { from { width: 0; } }
@keyframes typing { from { width: 0; } }
@-webkit-keyframes blink-car { 50% { border-color: transparent; } }
@keyframes blink-car { 50% { border-color: transparent; } }
.textboard-content {
  border-right: 5px solid;
  width: 21em; //fallback
  margin: 2%;
  white-space: nowrap;
  overflow: hidden;
  -webkit-animation: typing 5s steps(32, end),
    blink-car 1s infinite ease;
          animation: typing 5s steps(32, end),
    blink-car 1s infinite ease;
}

.gacha-wrapper{
  min-height: 800px;
  margin: 0 auto;
}

canvas{
  width: 100%;
  max-width: 400px;
  border-top: solid #ea2043 30px;
  border-radius: 20px;
}

.gachanodai{
  position: absolute;
  top: 52.6%;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  img{
    max-width: 600px;
  }
}

// ボタン2
.standard{
  position: absolute;
  bottom: 20%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  display: inline-block;
  font-size: 20px;
  text-decoration: none;
  color: rgb(30, 120, 150);
  background: #5dc3d0;
  width: 122px;
  height: 120px;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  -webkit-box-shadow: inset 0px 3px 0 rgba(255,255,255,0.3), 0 3px 3px rgba(0, 0, 0, 0.3);
          box-shadow: inset 0px 3px 0 rgba(255,255,255,0.3), 0 3px 3px rgba(0, 0, 0, 0.3);
  font-weight: bold;
  border: none;
  border-bottom: solid 3px #549fa9;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.65);
  -webkit-transition: .4s;
  transition: .4s;
}

.yagikore{
  max-width: 250px;
}

.empty-yagi{
  color: #000;
}

.login{
  text-align: center;
  color: #333;
}

@media (max-width: 600px){
  h1{
    margin-bottom: 0;
    img{
      max-width: 220px;
    }
  }
  .textboard {
    margin-top: 0;
  }
  .gacha-wrapper{
    min-height: 600px;
  }
  canvas{
    max-width: 320px;
  }
  .gachanodai{
    position: absolute;
    top: 55.7%;
    left: 50%;
    -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
    img{
      max-width: 450px;
    }
  }
  .standard{
    font-size: 0.9rem;
    width: 95px;
    height: 95px;
    bottom: 18%;
  }
  .statistics{
    margin: 0 10px 30px;
  }

  .rarity-1, .rarity-2, .rarity-3, .rarity-4, .rarity-5{
    margin: 0;
  }

  .close-button{
    max-width: 320px;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }

  .again{
    width: 80px;
    padding: 0;
  }

  .again img{
    width: 80px;
  }

  .close{
    width: 80px;
    padding: 0;

  }
  .close img{
    max-width: 60px;
  }
}

@media (max-width: 450px){
  h1 img{
    max-width: 200px;
  }

  .textboard {
    font-size: 0.8rem;
  }

  .gacha-wrapper{
    min-height: 450px;
  }

  canvas{
    border-top: solid #ea2043 20px;
    max-width: 230px;
  }

  .gachanodai{
    position: absolute;
    top: 56%;
    -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
    img{
      max-width: 320px;
    }
  }

  .standard{
    font-size: 0.6rem;
    width: 65px;
    height: 65px;
    bottom: 18%;
    padding: 0;
  }

  .result-yagi-image{
    background-size: 100%;
  }
  .again{
    border-radius: 0;
  }
  .close{
    border-radius: 0;
  }
}
</style>
<script>
import Matter from 'matter-js'
import decomp from 'poly-decomp'
// const Vertices = Matter.Vertices
// Fetch our canvas
import omikujiTableRaw from '@/assets/omikuji/index'
import _ from '@/assets/lib/my-lodash'
// import _ from '@/assets/lib/my-lodash'
window.decomp = decomp
const World = Matter.World
const Engine = Matter.Engine
const Render = Matter.Render
const Composites = Matter.Composites
const Body = Matter.Body
const Bodies = Matter.Bodies
const Events = Matter.Events
const Constraint = Matter.Constraint
const Composite = Matter.Composite
// const MouseConstraint = Matter.MouseConstraint
const raritySetting = {
  1: 60,
  2: 30,
  3: 15,
  4: 7,
  5: 3
}
const rarityTable = (() => {
  let table = []
  for (let rarity in raritySetting) {
    let rarityArray = _.fill(new Array(raritySetting[rarity]), rarity)
    table = table.concat(rarityArray)
  }
  return table
})()
const GOSENCHOEN_API_URL = process.env.VUE_APP_GOSENCHOEN_API_URL

const sleep = (waitSeconds, someFunction) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(someFunction())
    }, waitSeconds)
  })
}
const WORLD_SIZE = 640
export default {
  data: function () {
    return {
      floorPlug: {},
      fallSensor: {},
      mixer: {},
      omikuji: null,
      omikujiTable: [],
      omikujiSrc: '',
      omikujiUrl: '',
      imgSrcTop: '',
      imgSrcBottom: '',
      nowLoding: false,
      errorMessage: '',
      omikujiStatistics: {},
      omikujiStatisticsListener: {},
      windowWidth: 0,
      windowHeight: 0,
      worldHeight: 0
    }
  },
  computed: {
    rarityClass: function () {
      let classObj = {}
      if (this.omikuji) {
        classObj['rarity-' + this.omikuji.rarity] = true
      }
      return classObj
    },
    rarityLabel: function () {
      if (!this.omikuji.emoji) return ''
      return this.omikuji.emoji.repeat(this.omikuji.rarity)
    },
    rateTable: function () {
      let sum = 0
      let rate = {}
      for (let val in raritySetting) {
        sum += raritySetting[val]
      }
      for (let key in raritySetting) {
        rate[key] = (raritySetting[key] / sum * 100).toFixed(2)
      }
      return rate
    },
    worldStyle: function () {
      return {}
    },
    worldWrapperStyle: function () {
      const clientSize = Math.min(this.windowWidth, this.windowHeight)
      const scale = clientSize / Math.max(clientSize, WORLD_SIZE)
      if (this.worldHeight) {
        return {
          'max-height': this.worldHeight * scale + 'px'
        }
      } else {
        return {}
      }
    }
  },
  methods: {
    loadOmikujiTable: function () {
      let table = []
      for (let row of omikujiTableRaw) {
        table.push({
          rarity: row[0],
          messages: [row[1], row[2]],
          emoji: row[3]
        })
      }
      this.omikujiTable = table
    },
    getRarity: function () {
      return _.sample(rarityTable)
    },
    getOmikuji: function (rarity) {
      const result = _.sample(this.omikujiTable.filter(omikuji => Number(omikuji.rarity) === Number(rarity)))
      if (result) {
        return result
      } else {
        console.error('getOmikuji failed')
      }
    },
    $_createOmikujiParams: function (omikuji) {
      if (!omikuji) return
      let params
      try {
        params = {
          line1: omikuji.messages[0],
          line2: omikuji.messages[1],
          rarity: omikuji.rarity,
          emoji: omikuji.emoji
        }
      } catch (e) {
        console.error(e)
        return
      }
      return params
    },
    pullOmikuji: async function (rarity) {
      // const rarity = this.getRarity()
      if (this.nowLoding) {
        console.log('this.nowLoding', this.nowLoding)
        return
      }
      this.nowLoding = true
      await sleep(rarity * 50, () => {})
      this.$modal.show('omikuji-dialog')
      this.omikuji = {}
      this.errorMessage = ''
      // await sleep(rarity * 100 + 150, () => {})
      this.yagiImgSrc = this.getYagiImgByRarity(rarity)
      this.omikuji = this.getOmikuji(rarity)
      const params = this.$_createOmikujiParams(this.omikuji)
      if (!params) {
        console.error('createOmikujiParams failed')
        return
      }
      await sleep(450 * rarity + 150, () => {})
      const app = this
      this.$axios.get(GOSENCHOEN_API_URL, {
        params: params,
        responseType: 'arraybuffer'
      }).then(response => {
        this.omikujiUrl = response.request.responseURL
        this.omikujiSrc = 'data:image/png;base64,' + Buffer.from(response.data).toString('base64')
        this.nowLoding = false
        if (app.$firebase.isAuthenticated) {
          app.$firebase.addOmikujiLog(this.omikuji)
            .then(function (docRef) {
              console.log('おみくじ保存成功', docRef.id)
            })
            .catch(function (error) {
              console.error(error)
              app.$message({
                type: 'error',
                message: 'おみくじ保存失敗'
              })
            })
        }
      }).catch(err => {
        console.log(err, this.omikuji)
        this.errorMessage = err
        this.nowLoding = false
      })
    },
    getYagiImgByRarity: function (rarity) {
      const imgs = {
        1: 'yagi-white.png',
        2: 'yagi-lightcyan.png',
        3: 'yagi-skyblue.png',
        4: 'yagi-plum.png',
        5: 'yagi-gold.png'
      }
      return '/static/img/gacha/' + imgs[rarity]
    },
    openPlug: async function () {
      this.omikuji = {}
      this.yagiImgSrc = ''
      this.omikujiSrc = false
      // Body.setAngularVelocity(this.mixer, 0.07)
      await sleep(500 * Math.random(), () => {})
      this.floorPlug.render.visible = false
      this.floorPlug.isSensor = true
    },
    closePlug: function () {
      this.floorPlug.isSensor = false
      this.floorPlug.render.visible = true
    },
    listenOmikujiStatistics: function () {
      if (!this.$firebase.isAuthenticated) return
      const app = this
      this.omikujiStatisticsListener = this.$firebase.omikujiStatisticsOnSnapshot(function (doc) {
        app.omikujiStatistics = doc.data()
      })
    }
  },
  mounted: function () {
    const app = this
    const canvas = this.$refs.world
    // Setup Matter JS
    const engine = Engine.create()
    const world = engine.world
    // const clientSize = Math.min(this.$refs.fullscreen.clientWidth, this.$refs.fullscreen.clientHeight)
    const yagiSize = WORLD_SIZE / 10
    const wallWidth = 300
    const bottomHeight = yagiSize / 1.5
    const worldWidth = WORLD_SIZE
    const worldHeight = WORLD_SIZE
    const mixerSpeed = 0.03
    const render = Render.create({
      canvas: canvas,
      engine: engine,
      options: {
        width: worldWidth,
        height: worldHeight + bottomHeight + 550,
        scale: 0.5,
        background: '#cdc',
        wireframes: false,
        yagiImgSrc: '',
        showAngleIndicator: false
      }
    })
    /*
    const polygonStr = `57 22, 59 19, 58 16, 58 16, 55 16, 56 16, 55 19, 54 20, 50 18, 36 20, 30 19, 26 18, 21 15, 22 12, 20 8, 21 7, 23 6, 24 5, 25 4, 25 4, 25 4, 25 4, 25 3, 25 3, 25 3, 25 2, 25 2, 25 2, 25 2, 25 2, 25 2, 25 2, 25 2, 25 2, 25 1, 25 1, 25 1, 25 1, 25 1, 25 1, 25 1, 25 1, 25 1, 25 1, 25 0, 25 0, 25 0, 25 1, 25 1, 22 2, 22 2, 19 2, 18 3, 17 4, 17 4, 17 4, 17 5, 17 5, 17 5, 14 4, 14 4, 13 3, 12 4, 12 4, 9 5, 9 2, 9 0, 7 1, 4 5, 5 8, 3 10, 2 15, 3 18, 4 18, 1 21, 5 24, 6 24, 6 25, 7 24, 8 24, 8 24, 8 25, 8 26, 9 25, 9 26, 9 25, 10 24, 10 23, 13 23, 14 24, 14 29, 14 29, 14 30, 14 30, 14 31, 14 31, 14 33, 14 33, 15 34, 15 35, 15 35, 15 36, 16 36, 16 36, 16 37, 16 37, 17 38, 17 38, 17 38, 18 40, 20 45, 20 46, 20 46, 20 46, 20 46, 20 47, 20 47, 20 47, 20 47, 20 48, 20 48, 20 48, 21 51, 21 53, 19 55, 19 58, 19 58, 19 58, 23 58, 23 58, 23 58, 23 58, 25 57, 26 56, 26 54, 27 54, 27 54, 27 52, 27 51, 27 50, 27 49, 26 44, 26 44, 35 44, 42 43, 46 47, 46 51, 46 51, 46 52, 46 52, 46 53, 44 55, 44 55, 44 55, 44 56, 45 56, 45 56, 46 57, 46 58, 46 59, 46 59, 49 58, 50 58, 50 58, 50 58, 51 57, 53 56, 53 54, 52 53, 52 53, 52 53, 54 50, 54 50, 55 50, 55 49, 56 46, 56 44, 56 44, 54 42, 54 42, 54 42, 54 42, 54 42, 54 38, 54 38, 54 38, 54 38, 54 37, 54 37, 57 24, 56 22, 57 22`
    const polygonArray =  _.uniq(polygonStr.split(','))
    // polygonArray.sort()
    let yagiVertices = []
    for(let p of polygonArray){
      let xy = p.trim().split(' ')
      yagiVertices.push({x: Number(xy[0]), y: Number(xy[1])})
    }
    */
    // console.log(yagiVertices)
    /*
    const yagiV = Bodies.fromVertices(0, 0, yagiVertices)
    World.add(world, yagiV)
    */
    // Matter.World.add(world, yagi);
    // Matter.Composites.stack(xx, yy, columns, rows, columnGap, rowGap, callback)
    /*
    const yagiVertice = Vertices.fromPath(`L26.5,54l0.1-0.1c0.7-0.6,0.5-1.5,0.2-1.9l-0.2-0.7c0.1-0.4,0.1-0.8,0-1.3c0-0.2,0.1-0.4,0.2-0.6c0.4-1.4-0.3-3.6-0.9-5.1c0-0.1,0.1-0.3,0.1-0.5c2.5,0.6,5.6,0.8,9.1,0.5c2.4-0.2,4.7-0.8,7-1.4c1.6,1.7,2.8,2.4,3.7,3.6c1.1,2.9,0.2,3.7,0.4,4.4c0,0.1,0.1,0.2,0.1,0.2c0,0.1-0.1,0.3-0.1,0.4l0,0l-0.3,1.7c-1.4,0.1-1.7,1-1.7,1.8c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.5,0.1,0.9,0.1,0.9c0,0.1,0.1,0.1,0.3,0.2c0,0.1,0,0.1,0,0.1c0,0.2,0.4,0.2,1,0.1c-0.3,0.8,0,1.8,0,1.8c0,0.1,0.1,0.1,0.3,0.2c0,0.1,0,0.1,0,0.1c0.1,0.4,2.4-0.1,3.3-0.2c0.2,0,0.3,0,0.4,0l0,0c0.1,0,0.2,0,0.3,0l1.4-1.4l1.3-0.8c0.7-0.6,0.5-1.5,0.2-1.9l-0.3-1l0,0c0-0.1-0.1-0.1-0.1-0.2c0.2-0.6,0.6-1.8,1.6-2.9c0.2-0.1,0.3-0.2,0.5-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1-0.1,0.1-0.1c0.8-0.9,1.3-2,1.3-3.2c0-0.7-0.1-1.3-0.4-1.9c0-0.1-0.1-0.2-0.1-0.3c-0.4-0.8-0.8-1.1-1.2-1.9c0-0.1-0.1-0.2-0.1-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2c-0.5-1.1-0.6-2.3-0.4-3.4l0,0c0,0,0-0.1,0-0.1l0,0c0.1-0.2,0.2-0.6,0.4-1.1c0,0,0,0,0.1-0.1c5.6-6.1,3.8-10.3,2.6-12.9c-0.3-0.6-0.6-1.1-1-1.6C56.1,22.2,56.6,22.1,57.3,21.7z`)
    console.log(yagiVertice)
    */

    const createYagiBody = function (x, y) {
      let rarity = app.getRarity()
      return Bodies.circle(x, y, yagiSize / 2, {
        density: 0.01 + 0.01 / rarity,
        label: rarity,
        restitution: 0.88,
        friction: 0.01,
        frictionAir: 0.001,
        frictionStatic: 0.01,
        render: {
          sprite: {
            texture: app.getYagiImgByRarity([rarity]),
            xScale: yagiSize / 60,
            yScale: yagiSize / 60
          }
        }
      })
    }
    const yagis = Composites.stack(0, -100, 5, 5, yagiSize, yagiSize, createYagiBody)
    const mixerSize = Math.min(worldWidth, worldHeight)
    const mixer = Bodies.rectangle(worldWidth / 2, worldHeight, mixerSize, yagiSize / 3, {
      density: 20,
      restitution: 0.85
    })
    // Body.setAngularVelocity(mixer, 0.1)
    const mixerConstraint = Constraint.create({
      pointA: {
        x: worldWidth / 2,
        y: worldHeight - worldWidth / 2 - bottomHeight
      },
      bodyB: mixer,
      length: 0
    })
    Events.on(engine, 'afterUpdate', function () {
      Body.setAngle(mixer, mixer.angle + mixerSpeed)
    })

    // Add a floor
    const holeWidth = yagiSize + 20
    const leftWall = Bodies.rectangle(0 - wallWidth / 2 + 1, worldHeight / 2, wallWidth, worldHeight * 2, {
      isStatic: true, // An immovable object
      render: {
        fillStyle: '#000'
      }
    })
    const rightWall = Bodies.rectangle(worldWidth + wallWidth / 2 - 1, worldHeight / 2, wallWidth, worldHeight * 2, {
      isStatic: true, // An immovable object
      render: {
        fillStyle: '#000'
      }
    })
    const topWall = Bodies.rectangle(worldWidth / 2, -wallWidth / 2 - worldHeight / 2, worldWidth, wallWidth, {
      isStatic: true, // An immovable object
      render: {
        fillStyle: '#000'
      }
    })
    const cornerSize = worldWidth / 3.14
    const bottomCornerLeft = Matter.Bodies.fromVertices(0 + yagiSize / 3, worldHeight - bottomHeight - yagiSize / (3 / 2),
      [
        {
          x: 0, y: 0
        },
        {
          x: cornerSize, y: 0
        },
        {
          x: 0, y: cornerSize
        }
      ],
      {
        angle: 4.71239,
        isStatic: true
      }
    )
    const bottomCornerRight = Matter.Bodies.fromVertices(worldWidth - yagiSize / 3, worldHeight - bottomHeight - yagiSize / (3 / 2),
      [
        {
          'x': 0, 'y': 0
        },
        {
          'x': cornerSize, 'y': 0
        },
        {
          'x': 0, 'y': cornerSize
        }
      ],
      {
        angle: 3.14159,
        isStatic: true
      })
    const plugHeight = 30
    this.floorPlug = Bodies.rectangle(worldWidth / 2, worldHeight - bottomHeight + plugHeight / 2, holeWidth, plugHeight, {
      id: 'floorPlug',
      isStatic: true, // An immovable object
      isSensor: false,
      render: {
        fillStyle: '#F00'
      }
    })
    this.fallSensor = Bodies.rectangle(worldWidth / 2, worldHeight + wallWidth / 2 - bottomHeight - yagiSize, 10, 10, {
      id: 'floorSensor',
      isStatic: true, // An immovable object
      isSensor: true,
      render: {
        visible: true
      }
    })

    const floorLeft = Bodies.rectangle(-holeWidth / 2, worldHeight + wallWidth / 2 - bottomHeight + 70, worldWidth, wallWidth + 140, {
      isStatic: true, // An immovable object
      render: {

      }
    })
    const floorRight = Bodies.rectangle(worldWidth + holeWidth / 2, worldHeight + wallWidth / 2 - bottomHeight + 70, worldWidth, wallWidth + 140, {
      isStatic: true, // An immovable object
      render: {

      }
    })
    // Make interactive
    /*
    const mouseConstraint = MouseConstraint.create(engine, { // Create Constraint
      element: canvas,
      constraint: {
        render: {
          visible: true
        },
        stiffness: 0.8
      }
    })
    */
    // Composites.stack(xx, yy, columns, rows, columnGap, rowGap, callback)
    // worldHeight - bottomHeight
    /*
    // ヤギの上に重ねるためにstackを使用
    var mask = Composites.stack(0, worldHeight - bottomHeight - yagiSize, 1, 1, 0, 0, function (x, y) {
      return Bodies.rectangle(x, y, worldWidth, yagiSize,
        {
          isStatic: true,
          collisionFilter: {
            category: 'mask'
          },
          render: {
            opacity: 0.99
          }
        }
      )
    })
    */

    World.add(world, [
      mixer,
      yagis,
      // mask,
      mixerConstraint,
      floorLeft,
      bottomCornerLeft,
      floorRight,
      bottomCornerRight,
      leftWall,
      rightWall,
      topWall,
      // mouseConstraint,
      this.floorPlug,
      this.fallSensor
    ])
    Events.on(engine, 'collisionEnd', async function (event) {
      for (let p of event.pairs) {
        if (p.isSensor === true && (p.bodyA.id === 'floorSensor' || p.bodyB.id === 'floorSensor')) {
          let target = Composite.get(world, p.bodyB.id, 'body')
          target.render.sprite.xScale = target.render.sprite.xScale * 2
          target.render.sprite.yScale = target.render.sprite.yScale * 2
          await sleep(1500, () => {})
          Composite.remove(world, target, 'body')
          let addingYagi = createYagiBody(worldWidth / 2, 0)
          World.add(world, addingYagi)
        }
      }
    })
    Events.on(engine, 'collisionStart', async function (event) {
      for (let p of event.pairs) {
        if (p.isSensor === true && (p.bodyA.id === 'floorSensor' || p.bodyB.id === 'floorSensor')) {
          console.log('floorSensor', p.bodyB.id)
          app.closePlug()
          await sleep(500, () => {})
          app.pullOmikuji(p.bodyB.label)
        }
      }
    })
    Engine.run(engine)
    Render.run(render)
    this.$eventHub.$on('firebase-initialized', this.listenOmikujiStatistics)
    this.listenOmikujiStatistics()

    this.$nextTick(function () {
      this.windowWidth = this.$refs.fullscreen.clientWidth
      this.windowHeight = this.$refs.fullscreen.clientHeight
      this.worldHeight = canvas.height
    })
  },
  beforeMount: function () {
    this.loadOmikujiTable()
  },
  destroyed: function () {
    // unscribe
    this.$eventHub.$off('firebase-initialized', this.listenOmikujiStatistics)
    if (this.omikujiStatisticsListener) this.omikujiStatisticsListener()
  }
}
</script>
